import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';
import getAccountShipmentV2 from '../getAccountShipmentV2';

export type PatchAccountShipmentV2Payload = {
  name?: string;
  carrier?: string | null;
  notes?: string | null;
  asset_value?: number | null;
};

export type PatchAccountShipmentV2Variables = {
  accountId: number;
  shipmentId: number;
  payload: PatchAccountShipmentV2Payload;
};

/**
 * PATCH `/api/v2/accounts/{account}/shipments/{shipment}` — draft metadata (name, carrier, notes).
 */
export default function usePatchAccountShipmentV2() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      accountId,
      shipmentId,
      payload,
    }: PatchAccountShipmentV2Variables) => {
      const { api, baseURL } = getApi();
      const res = await api.patch(
        `/api/v2/accounts/${accountId}/shipments/${shipmentId}`,
        payload,
        { baseURL },
      );
      return (res.data?.data ?? res.data) as unknown;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['account-shipments'] });
      queryClient.invalidateQueries({
        queryKey: getAccountShipmentV2.queryKey(
          variables.accountId,
          variables.shipmentId,
        ),
      });
    },
  });
}
